import React from 'react';

import { BottomSheetBackdrop } from '@gorhom/bottom-sheet';
import { BottomSheetDefaultBackdropProps } from '@gorhom/bottom-sheet/lib/typescript/components/bottomSheetBackdrop/types';

import styles from './styles';

function ModalBackdrop(props: BottomSheetDefaultBackdropProps) {
    return (
        <BottomSheetBackdrop
            {...props}
            style={styles.root}
            opacity={0.8}
            disappearsOnIndex={-1}
        />
    );
}

export default ModalBackdrop;
